import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { getOsName } from "@faire/retailer-visitor-shared/lib/user-agent/osName";
import { getIsProduction, getSafeEnvName } from "@faire/retailer-visitor-shared/serialized-data/getEnvName";
import { getFaireBaseUrl } from "@faire/retailer-visitor-shared/serialized-data/getFaireBaseUrl";
import { getIsAppInstalled } from "@faire/retailer-visitor-shared/serialized-data/getIsAppInstalled";
import { useSettingAppPromotionBannerLinks } from "@faire/retailer-visitor-shared/settings/useSettingAppPromotionBannerLinks";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { Storage } from "@faire/web--source/common/Storage";
import addDays from "date-fns/addDays";
import isEmpty from "lodash/isEmpty";
import { useCallback, useEffect, useMemo, useState } from "react";
import { matchPath } from "react-router-dom";
export var BANNER_FLAG_TIMESTAMP = "retailer_mobile-app-banner-flag-timestamp";
var DISMISS_INTERVAL_DAYS = 1;
export var OSType;
(function(OSType) {
    OSType["IOS"] = "iOS";
    OSType["ANDROID"] = "Android";
})(OSType || (OSType = {}));
export var useMobileAppBannerService = function() {
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var _useState = _sliced_to_array(useState(false), 2), showBanner = _useState[0], setShowBanner = _useState[1];
    var storeLinks = useSettingAppPromotionBannerLinks();
    var storeLinkUrl = useMemo(function() {
        if (getOsName() === OSType.IOS) {
            return storeLinks.app_store_link;
        } else if (getOsName() === OSType.ANDROID) {
            return storeLinks.play_store_link;
        }
        return undefined;
    }, [
        storeLinks.app_store_link,
        storeLinks.play_store_link
    ]);
    var deepLinkUrl = useMemo(function() {
        if (getOsName() === OSType.IOS) {
            return storeLinks.ios_deep_link;
        } else if (getOsName() === OSType.ANDROID) {
            return storeLinks.android_deep_link;
        }
        return undefined;
    }, [
        storeLinks.android_deep_link,
        storeLinks.ios_deep_link
    ]);
    var bannerLinkUrl = useMemo(function() {
        var linkUrl = !!getIsAppInstalled() && deepLinkUrl || storeLinkUrl;
        return linkUrl;
    }, [
        deepLinkUrl,
        storeLinkUrl
    ]);
    var shouldShowBanner = !isMobileApp() && !isEmpty(bannerLinkUrl) && !!userToken;
    useEffect(function() {
        setShowBanner(shouldShowBanner);
    }, [
        shouldShowBanner
    ]);
    var dismissBanner = useCallback(function() {
        Storage.local.setItem(BANNER_FLAG_TIMESTAMP, addDays(new Date(), DISMISS_INTERVAL_DAYS).getTime().toString());
        setShowBanner(false);
    }, []);
    var updateBannerAvailibility = useCallback(function() {
        setShowBanner(shouldShowBanner);
    }, [
        shouldShowBanner
    ]);
    return {
        showBanner: showBanner,
        dismissBanner: dismissBanner,
        updateBannerAvailibility: updateBannerAvailibility
    };
};
export var getDeepLinkUrl = function(location, queryParams) {
    var onSearchPage = !!matchPath(location.pathname, {
        path: "/search",
        exact: true
    });
    var pathName;
    if (onSearchPage) {
        pathName = "".concat(location.pathname, "?q=").concat(queryParams === null || queryParams === void 0 ? void 0 : queryParams.getOrDefault("q", ""));
    } else {
        pathName = location.pathname;
    }
    return "https://faireretailer.page.link/?link=".concat("https://www.".concat(getFaireBaseUrl())).concat(pathName, "&efr=1&apn=").concat(getIsProduction() ? "com.faire.retailer" : "com.faire.retailer.internal", "&isi=1413340491&ibi=").concat("com.indigofair.".concat(getSafeEnvName()));
};
